import OfferEvent from '@core/models/offer/OfferEvent';

export const getTournamentName = (event: OfferEvent): string => {
    const { categoryName, tournamentName } = event;

    const splitTournamentName = tournamentName.split(' - ');

    // if tournamentName starts with categoryName, remove it to avoid duplicate labels and shorten the general title
    if (categoryName && splitTournamentName[0].trim().startsWith(categoryName.trim())) {
        return splitTournamentName.slice(1).join(' - ');
    }

    return tournamentName;
};
